import { render } from "./buttonField2.vue?vue&type=template&id=5e20d08a"
import script from "./buttonField2.vue?vue&type=script&lang=js"
export * from "./buttonField2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__